import api from '@/api'
import local from './localStorage.js'
import session from './sessionStorage.js'
import timeTransfer from './timeTransfer.js'

export default {
  install: function (vm) {
    vm.prototype.$local = local
    vm.prototype.$session = session
    vm.prototype.$timeTransfer = timeTransfer
    vm.prototype.$api = api
  }
}

